import { createRef } from "react";
import { ExpendTextAreaByProps } from "../../../../../../base/basicComponents/input";
import ReturnReasonHypelink from "../../../../../../base/basicComponents/returnReasonHypelink";
import ApproveUpdateSupportingFileTbody from "../../../../supportingFileSections/fields/supportingFileTbody/approveUpdateSupportingFileTbody";

const ReturnResonRef = createRef();
export default class ApproveUpdateProcedureFileTbody extends ApproveUpdateSupportingFileTbody {
  /**
   * function about show input if column type is input
   * @param {*} row
   * @param {*} rowColumn
   * @param {*} column
   * @param {*} rowIndex
   * @param {*} isShowReturnReason
   * @param {*} procedureNoteMaxLength
   * @returns
   */
  returnInput = (
    row: any,
    rowColumn: any,
    column: any,
    rowIndex: any,
    isShowReturnReason: any,
    procedureNoteMaxLength: any
  ) => {
    return (
      <>
        {rowColumn.name === "returnReason" ? (
          isShowReturnReason && (
            <>
              <ReturnReasonHypelink
                inputRef={ReturnResonRef}
                value={rowColumn.value}
                rowindex={rowIndex}
                isShowEditBtn={rowColumn.value !== null && column.showEdit}
                handleReturnEditClick={(e: any) => {
                  this.props.handleReturnClick(e);
                }}
                isShowReasonLogIcon={rowColumn.isShowReasonLog}
                reasonLog={rowColumn.reasonLog}
                isTable={true}
              />
            </>
          )
        ) : (
          <ExpendTextAreaByProps
            value={rowColumn.value}
            onChange={(ele: any) => this.props.inputOnChange(ele.target)}
            maxLength={procedureNoteMaxLength}
            disabled={true}
            dataname={column.dataName}
            rowindex={rowIndex}
            style={{
              display: column.isShow ? "table-cell" : "none",
            }}
            ref={column.ref}
            readOnly={rowColumn.readOnly}
            handleTableChange={this.props.handleChangeTableHeight}
            isExpendData={this.props.isExpendData}
          />
        )}
      </>
    );
  };
}
